// extracted by mini-css-extract-plugin
export var active = "_dy-2";
export var recordingDot = "_dy-1";
export var recordingIndicator = "_dy-0";